<script>
import weightRangeMixin from '@/views/product/components/product-card/fmd/mixins/weightRange'
import { BAlert } from 'bootstrap-vue'

export default {
    name: 'MaterialWeightSummary',
    components: {BAlert},
    mixins: [weightRangeMixin],
    props: {
        declarations: {
            type: Array,
            default() {
                return []
            },
        },
    },
    computed: {
        summaryData() {
            let sumFrom = 0
            let sumTo = 0
            let hasAny = false

            this.declarations.forEach(group => {
                const weight = group && (group.materialWeight || group.weight) ? (group.materialWeight || group.weight) : null
                if (!weight) {
                    return
                }
                let from = this.normalizeNumber(weight.from)
                let to = this.normalizeNumber(weight.to)
                if (from === null && to === null) {
                    return
                }
                if (from === null) {
                    from = to
                }
                if (to === null) {
                    to = from
                }
                sumFrom += from
                sumTo += to
                hasAny = true
            })

            if (!hasAny) {
                return { text: '-', sumFrom: null }
            }

            if (sumFrom > 100) {
                sumFrom = 100
            }
            if (sumTo > 100) {
                sumTo = 100
            }

            const roundToThousands = value => Math.round(value * 1000) / 1000
            sumFrom = roundToThousands(sumFrom)
            sumTo = roundToThousands(sumTo)

            if (sumFrom === sumTo) {
                return { text: `${sumFrom}%`, sumFrom }
            }
            return { text: `${sumFrom} - ${sumTo}%`, sumFrom }
        },
        summaryText() {
            return this.summaryData.text
        },
        alertVariant() {
            const sumFrom = this.summaryData.sumFrom
            if (sumFrom !== null && sumFrom >= 95) {
                return 'success'
            }
            return 'warning'
        },
    },
}
</script>

<template>
    <div class="fmd-material-weight-summary">
        <b-alert :variant="alertVariant" show>
            <div class="alert-body">
                {{ $t('Component(FMDTab):material-weight-summary', { value: summaryText }) }}
            </div>
        </b-alert>
    </div>
</template>

<style scoped lang="scss">
.fmd-material-weight-summary .alert.alert-success {
    color: #0a4f29b3 !important;
}
</style>
